// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Button,
//   Typography,
//   Grid,
//   TableContainer,
//   Table,
//   TableHead,
//   TableBody,
//   Paper,
//   Modal,
//   IconButton,
//   DialogContent,
//   MenuItem,
//   TablePagination,
// } from "@mui/material";
// import {
//   BootstrapDialog,
//   BootstrapDialogTitle,
//   Breadcrumb,
//   CTSinput,
//   CTSRinput,
//   StyledTableCell,
//   StyledTableRow,
// } from "../../reusableComponent/Reusables";
// import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useForm, Controller } from "react-hook-form";
// import CloseIcon from "@mui/icons-material/Close";
// import { Print } from "@mui/icons-material";
// import styles from "../../../styles.module.css";
// import dayjs from "dayjs";
// import emptyCylinderInspectionService from "../../../services/emptyCylinderInspection.Service";
// import plantMasterService from "../../../services/masters/plantMaster.Service";
// import { useSelector } from "react-redux";

// // Enhanced print-specific CSS styles
// const printStyles = `
//   @media print {
   
//     body * {
//       visibility: hidden;
//     }
//     .printable-area, .printable-area * {
//       visibility: visible;
//     }
//     .printable-area {
//       position: absolute;
//       left: 0;
//       top: 0;
//       width: 100%;
//       overflow: hidden; /* Prevent scrollbars */
//     }
//     .no-print {
//       display: none !important;
//     }
//     .printable-table {
//       width: 100%;
//       table-layout: fixed; /* Ensure consistent column widths */
//       border-collapse: collapse;
//       page-break-inside: auto;
//       overflow: hidden; /* Prevent scrollbars in table */
//     }
//     .printable-table th, .printable-table td {
//       padding: 6px;
//       font-size: 12px !important;
     
//       text-align: left;
//       word-wrap: break-word; /* Wrap long text */
//     }
//     .printable-table th {
//       background-color: #f0f0f0;
//       font-weight: bold;
//     }
//     .printable-table tr:nth-child(even) {
//       background-color: #f9f9f9; /* Alternating row colors */
//     }
//     .printable-table tr {
//       page-break-inside: avoid;
//       page-break-after: auto;
//     }
//     .printable-header {
//       text-align: left;
//       margin-bottom: 15px;
//       font-size: 20px;
//       font-weight: bold;
//       color: #000;
//     }
//     .printable-subheader {
//       text-align: left;
//       margin-bottom: 15px;
//       font-size: 14px;
//       color: #333;
//     }
//     /* Ensure column widths are proportional */
//     .printable-table th:nth-child(1), .printable-table td:nth-child(1) { width: 8%; } /* Sr No */
//     .printable-table th:nth-child(2), .printable-table td:nth-child(2) { width: 15%; } /* Entry No */
//     .printable-table th:nth-child(3), .printable-table td:nth-child(3) { width: 10%; } /* Entry Date */
//     .printable-table th:nth-child(4), .printable-table td:nth-child(4) { width: 5%; } /* Shift */
//     .printable-table th:nth-child(5), .printable-table td:nth-child(5) { width: 10%; } /* Shift Time */
//     .printable-table th:nth-child(6), .printable-table td:nth-child(6) { width: 10%; } /* Done By */
//     .printable-table th:nth-child(7), .printable-table td:nth-child(7) { width: 10%; } /* Plant Name */
//     .printable-table th:nth-child(8), .printable-table td:nth-child(8) { width: 10%; } /* No of Cylinders */
//   }
// `;

// const EmptyCollectionReport = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const editData = location.state || null;

//   // Retrieve user session data
//   const login_details = sessionStorage.getItem("loginUser");
//   const userD = JSON.parse(login_details);
//   const userInfo = userD.result.userInfo;
//   const depot_id = userInfo.depot_id;
//   const plant_id = userInfo.plant_id;
//   const unit_id = userInfo.depot_id || userInfo.plant_id;
//   const short_code = userInfo.depot_short_code || userInfo.plant_short_code;

//   // Redux state for default rows per page
//   const defaultRowsPerPage = useSelector((state) => state.grn?.rows_per_page || 15);

//   // Local state
//   const [successMessage, setSuccessMessage] = useState("");
//   const [displayData, setDisplayData] = useState([]);
//   const [totalCount, setTotalCount] = useState(0);
//   const [plant, setPlant] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [openModal, setOpenModal] = useState(false);
//   const [selectedImage, setSelectedImage] = useState("");
//   const [info, setInfo] = useState([]);
//   const [openDetail, setDetail] = useState(false);
//   const [controller, setController] = useState({
//     page: 0,
//     rowsPerPage: defaultRowsPerPage,
//   });

//   // Date formatting utility
//   const dateConversion = (date) => {
//     if (!date) return "";
//     const today = new Date(date);
//     const dd = String(today.getDate()).padStart(2, "0");
//     const mm = String(today.getMonth() + 1).padStart(2, "0");
//     const yyyy = today.getFullYear();
//     return `${dd}/${mm}/${yyyy}`;
//   };

//   // Calculate pagination info
//   const effectiveTotalCount = totalCount > 0 ? totalCount : displayData.length;
//   const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
//   const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
//   const paginationInfo = `${startRecord}-${endRecord} of ${effectiveTotalCount}`;

//   // Form handling with react-hook-form
//   const {
//     control,
//     watch,
//     formState: { errors },
//   } = useForm({
//     defaultValues: {
//       entry_date_from: editData?.entry_date ? dayjs(editData.entry_date).format("YYYY-MM-DD") : "",
//       entry_date_to: "",
//       plant: "",
//     },
//     resolver: async (data) => {
//       const errors = {};
//       if (!data.entry_date_from) errors.entry_date_from = { message: "From Date is required" };
//       if (!data.entry_date_to) errors.entry_date_to = { message: "To Date is required" };
//       if (data.entry_date_from && data.entry_date_to && dayjs(data.entry_date_to).isBefore(dayjs(data.entry_date_from))) {
//         errors.entry_date_to = { message: "To Date cannot be before From Date" };
//       }
//       if (!data.plant) errors.plant = { message: "Plant is required" };
//       return { values: data, errors };
//     },
//   });

//   const entryDateFrom = watch("entry_date_from");
//   const entryDateTo = watch("entry_date_to");
//   const selectedPlant = watch("plant");

//   // Fetch plant data and apply print styles
//   useEffect(() => {
//     async function fetchData() {
//       try {
//         setLoading(true);
//         const plantData = await plantMasterService.getPlantList({
//           page: 0,
//           size: 999,
//           searchKey: "",
//         });
//         setPlant(plantData || []);
//       } catch (error) {
//         console.error("Error fetching plant data:", error);
//         setSuccessMessage("Error fetching plant data");
//         setPlant([]);
//       } finally {
//         setLoading(false);
//       }
//     }
//     fetchData();

//     // Apply print styles
//     const styleSheet = document.createElement("style");
//     styleSheet.type = "text/css";
//     styleSheet.innerText = printStyles;
//     document.head.appendChild(styleSheet);

//     return () => {
//       document.head.removeChild(styleSheet);
//     };
//   }, []);

//   // Fetch data when filters or pagination change
//   useEffect(() => {
//     setController((prev) => ({ ...prev, page: 0 }));
//     if (entryDateFrom && entryDateTo && selectedPlant && !errors.entry_date_from && !errors.entry_date_to && !errors.plant) {
//       handleShow({
//         entry_date_from: entryDateFrom,
//         entry_date_to: entryDateTo,
//         plant: selectedPlant,
//       });
//     }
//   }, [entryDateFrom, entryDateTo, selectedPlant, controller.page, controller.rowsPerPage]);

//   // Fetch report data
//   const handleShow = async (formData) => {
//     try {
//       setLoading(true);
//       setDisplayData([]);

//       const { entry_date_from, entry_date_to, plant } = formData;

//       if (!entry_date_from || !entry_date_to) {
//         setSuccessMessage("Both From Date and To Date are required");
//         setLoading(false);
//         return;
//       }

//       const filterParams = {
//         page: controller.page,
//         size: controller.rowsPerPage,
//         searchKey: "",
//         fromDate: entry_date_from,
//         toDate: entry_date_to,
//         from_plant_id: plant === "all" ? "" : plant,
//       };

//       const response = await emptyCylinderInspectionService.getEciReport(filterParams);
//       const fetchedData = response?.data || response || [];
//       const serverTotalCount = response?.total_count || fetchedData.length;

//       const filteredData = plant === "all" ? fetchedData : fetchedData.filter((row) => row.from_plant_id === Number(plant));

//       setDisplayData(filteredData);
//       setTotalCount(serverTotalCount);
//     } catch (error) {
//       console.error("Error fetching data for display:", error);
//       setSuccessMessage(error.message || "Error fetching data");
//       setDisplayData([]);
//       setTotalCount(0);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle image modal
//   const handleImageClick = (image) => {
//     setSelectedImage(image);
//     setOpenModal(true);
//   };

//   const handleCloseModal = () => {
//     setOpenModal(false);
//     setSelectedImage("");
//   };

//   // Handle print
//   const handlePrint = () => {
//     window.print();
//   };

//   // Handle details dialog
//   const handleDetails = (tableData) => {
//     const parsedData = JSON.parse(tableData);
//     setInfo(parsedData);
//     setDetail(true);
//   };

//   const handleClose = () => {
//     setDetail(false);
//   };

//   // Get plant name by ID
//   const getPlantName = (from_plant_id, short_code) => {
//     const plantData = plant.find((p) => p.plant_id === from_plant_id);
//     return plantData?.plant_name || short_code || "Unknown";
//   };

//   // Get selected plant name for print header
//   const getSelectedPlantName = () => {
//     if (selectedPlant === "all") return "All Plants";
//     const plantData = plant.find((p) => p.plant_id === Number(selectedPlant));
//     return plantData?.plant_name || "Unknown";
//   };

//   // Pagination handlers
//   const handleChangePage = (event, newPage) => {
//     setController({ ...controller, page: newPage });
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setController({
//       ...controller,
//       rowsPerPage: parseInt(event.target.value, 10),
//       page: 0,
//     });
//   };

//   return (
//     <Box className={styles.cts_page} sx={{ padding: "0px !important", margin: "0px !important" }}>
//       <Box className={styles.body}>
//         <Breadcrumb routeSegments={[{ name: "Inspection Report" }]} />
//         <Typography className={styles.header_txt}>INSPECTION REPORT</Typography>

//         {/* Filter Form */}
//         <form className="no-print">
//           <Grid container spacing={2}>
//             <Grid item xs={12} sm={6} md={4}>
//               <Box sx={{ display: "flex", alignItems: "center" }}>
//                 <Typography className={styles.label_Txt_add}>From Date</Typography>
//                 <Controller
//                   name="entry_date_from"
//                   control={control}
//                   rules={{ required: "From Date is required" }}
//                   render={({ field }) => (
//                     <CTSRinput
//                       size="small"
//                       fullWidth
//                       type="date"
//                       {...field}
//                       error={!!errors.entry_date_from}
//                       helperText={errors.entry_date_from?.message}
//                       InputProps={{ className: styles.CTSinput_Box }}
//                     />
//                   )}
//                 />
//               </Box>
//             </Grid>
//             <Grid item xs={12} sm={6} md={4}>
//               <Box sx={{ display: "flex", alignItems: "center" }}>
//                 <Typography className={styles.label_Txt_add}>To Date</Typography>
//                 <Controller
//                   name="entry_date_to"
//                   control={control}
//                   rules={{ required: "To Date is required" }}
//                   render={({ field }) => (
//                     <CTSRinput
//                       size="small"
//                       fullWidth
//                       type="date"
//                       {...field}
//                       error={!!errors.entry_date_to}
//                       helperText={errors.entry_date_to?.message}
//                       InputProps={{ className: styles.CTSinput_Box }}
//                     />
//                   )}
//                 />
//               </Box>
//             </Grid>
//             <Grid item xs={12} sm={6} md={4}>
//               <Box sx={{ display: "flex", alignItems: "center" }}>
//                 <Typography className={styles.label_Txt_add}>Plant</Typography>
//                 <Controller
//                   name="plant"
//                   control={control}
//                   rules={{ required: "Plant is required" }}
//                   render={({ field }) => (
//                     <CTSRinput
//                       select
//                       size="small"
//                       fullWidth
//                       {...field}
//                       error={!!errors.plant}
//                       helperText={errors.plant?.message}
//                       InputProps={{ className: styles.CTSinput_Box }}
//                     >
//                       <MenuItem value="">Select Plant</MenuItem>
//                       <MenuItem value="all">All Plants</MenuItem>
//                       {plant.map((plantItem) => (
//                         <MenuItem key={plantItem.plant_id} value={plantItem.plant_id}>
//                           {plantItem.plant_name}
//                         </MenuItem>
//                       ))}
//                     </CTSRinput>
//                   )}
//                 />
//               </Box>
//             </Grid>
//           </Grid>
//         </form>

//         {/* Table and Print Button */}
//         <Grid item xs={12} sx={{ mt: 4 }}>
//           <Paper sx={{ width: "100%" }}>
//             <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", padding: "10px" }} className="no-print">
//               <Button
//                 style={{ float: "right", cursor: "pointer" }}
//                 variant="outlined"
//                 startIcon={<Print />}
//                 onClick={handlePrint}
//                 disabled={displayData.length === 0}
//               >
//                 Print
//               </Button>
//             </Box>
//             <Box className="printable-area">
//              <Typography
//   variant="h1"
//   className="printable-header"
//   sx={{
//     display: "none",
//     textAlign: "left",
//     "@media print": {
//       display: "block",
//       textAlign: "left"
//     }
//   }}
// >
//   Inspection Report
// </Typography>

// <Typography
//   variant="h1"
//   className="printable-subheader"
//   sx={{
//     display: "none",
//     textAlign: "left",
//     "@media print": {
//       display: "block",
//       textAlign: "left"
//     }
//   }}
// >
//   {`Date Range: ${dateConversion(entryDateFrom)} to ${dateConversion(entryDateTo)} | Plant: ${getSelectedPlantName()}`}
// </Typography>

//               <TableContainer component={Paper} className={`$printable-table`} sx={{ overflowX: "hidden" }}>
//                 <Table size="small" stickyHeader className="printable-table">
//                   <TableHead >
//                     <StyledTableRow>
//                       <StyledTableCell   sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>Sr No</StyledTableCell>
//                       <StyledTableCell   sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>Entry No</StyledTableCell>
//                       <StyledTableCell   sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>Entry Date</StyledTableCell>
//                       <StyledTableCell   sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>Shift</StyledTableCell>
//                       <StyledTableCell   sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>Shift Time</StyledTableCell>
//                       <StyledTableCell   sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>Done By</StyledTableCell>
//                       <StyledTableCell   sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>Plant Name</StyledTableCell>
//                       <StyledTableCell   sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>No of Cyl</StyledTableCell>
//                     </StyledTableRow>
//                   </TableHead>
//                   <TableBody sx={{ backgroundColor: "#fff" }}>
//                     {loading ? (
//                       <StyledTableRow>
//                         <StyledTableCell colSpan={8} align="center">
//                           <Typography>Loading data...</Typography>
//                         </StyledTableCell>
//                       </StyledTableRow>
//                     ) : displayData.length === 0 ? (
//                       <StyledTableRow>
//                         <StyledTableCell colSpan={8} align="center">
//                           <Typography>No data found</Typography>
//                         </StyledTableCell>
//                       </StyledTableRow>
//                     ) : (
//                       displayData.map((row, index) => (
//                         <StyledTableRow key={index}>
//                           <StyledTableCell align="left">
//                             {controller.page * controller.rowsPerPage + index + 1}
//                           </StyledTableCell>
//                           <StyledTableCell className={styles.inspection_cell}>{row.entry_no}</StyledTableCell>
//                           <StyledTableCell className={styles.inspection_cell}>
//                             {dateConversion(row.entry_date)}
//                           </StyledTableCell>
//                           <StyledTableCell className={styles.inspection_cell}>{row.shift}</StyledTableCell>
//                           <StyledTableCell className={styles.inspection_cell}>{row.shift_time}</StyledTableCell>
//                           <StyledTableCell className={styles.inspection_cell}>{row.done_by}</StyledTableCell>
//                           <StyledTableCell className={styles.inspection_cell}>
//                             {getPlantName(row.from_plant_id, row.short_code)}
//                           </StyledTableCell>
//                           <StyledTableCell
//                             sx={{ color: "blue", cursor: "pointer" }}
//                             align="left"
//                             className={styles.inspection_cell}
//                             onClick={() => handleDetails(row.tableData)}
//                           >
//                             {JSON.parse(row.tableData)?.length || 0}
//                           </StyledTableCell>
//                         </StyledTableRow>
//                       ))
//                     )}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             </Box>
//             <TablePagination
//               rowsPerPageOptions={[10, 25, 100]}
//               component="div"
//               count={effectiveTotalCount}
//               rowsPerPage={controller.rowsPerPage}
//               page={controller.page}
//               onPageChange={handleChangePage}
//               onRowsPerPageChange={handleChangeRowsPerPage}
//               className="no-print"
//             />
//           </Paper>
//         </Grid>

//         {/* Snackbar for success/error messages */}
//         <ReusableSnackbar
//           open={!!successMessage}
//           onClose={() => setSuccessMessage("")}
//           message={successMessage}
//           autoHideDuration={2000}
//           vertical="top"
//           horizontal="right"
//           className="no-print"
//         />

//         {/* Modal for image preview */}
//         <Modal
//           open={openModal}
//           onClose={handleCloseModal}
//           aria-labelledby="image-modal-title"
//           aria-describedby="image-modal-description"
//           sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
//           className="no-print"
//         >
//           <Box
//             sx={{
//               position: "relative",
//               maxWidth: "90%",
//               maxHeight: "90%",
//               bgcolor: "background.paper",
//               boxShadow: 24,
//               p: 2,
//               borderRadius: 2,
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//             }}
//           >
//             <IconButton sx={{ position: "absolute", top: 8, right: 8, zIndex: 1 }} onClick={handleCloseModal}>
//               <CloseIcon />
//             </IconButton>
//             <img
//               src={selectedImage}
//               alt="Full-size receipt"
//               style={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain" }}
//               onError={(e) => {
//                 e.target.src = "/path/to/fallback/image.jpg";
//               }}
//             />
//           </Box>
//         </Modal>

//         {/* Dialog for detailed cylinder data */}
//         <BootstrapDialog
//           PaperProps={{ sx: { minWidth: "90%", maxHeight: "90%" } }}
//           onClose={handleClose}
//           open={openDetail}
//           className="no-print"
//         >
//           <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
//             Details
//           </BootstrapDialogTitle>
//           <DialogContent dividers>
//             <TableContainer component={Paper} className={`${styles.list_tbl_container} printable-table`}>
//               <Table size="small" stickyHeader className="printable-table">
//                 <TableHead className={styles.table_head_container}>
//                   <StyledTableRow>
//                     <StyledTableCell align="left">Sr No</StyledTableCell>
//                     <StyledTableCell align="left">Cylinder No</StyledTableCell>
//                     <StyledTableCell align="left">Tag No</StyledTableCell>
//                     <StyledTableCell align="left">Valve Condition</StyledTableCell>
//                     <StyledTableCell align="left">Fusible Plug</StyledTableCell>
//                     <StyledTableCell align="left">Painting</StyledTableCell>
//                     <StyledTableCell align="left">Cyl Cap Avl</StyledTableCell>
//                     <StyledTableCell align="left">Result</StyledTableCell>
//                     <StyledTableCell align="left">Current Tare Wt</StyledTableCell>
//                     <StyledTableCell align="left">Actual Tare Wt</StyledTableCell>
//                     <StyledTableCell align="left">Actual Tare Wt (After Solvent)</StyledTableCell>
//                     <StyledTableCell align="left">Qty Of Solvent</StyledTableCell>
//                     <StyledTableCell align="left">Acetone Drum Tag No</StyledTableCell>
//                   </StyledTableRow>
//                 </TableHead>
//                 <TableBody sx={{ backgroundColor: "#fff" }}>
//                   {info.map((row, index) => (
//                     <StyledTableRow key={index}>
//                       <StyledTableCell align="center">{index + 1}</StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>{row.cylinder_no}</StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>{row.tag_no}</StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>{row.valve_condition}</StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>{row.fusible_plug}</StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>{row.painting}</StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>{row.cyl_cap_avl}</StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>{row.eci_result}</StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>{row.current_tare_wt}</StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>{row.actual_tare_wt}</StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>{row.actual_tare_wt_aft_sol}</StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>
//                         {parseFloat(row.qty_solvent).toFixed(2)}
//                       </StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>{row.acetone_drum_tag_no}</StyledTableCell>
//                     </StyledTableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           </DialogContent>
//         </BootstrapDialog>
//       </Box>
//     </Box>
//   );
// };

// export default EmptyCollectionReport;

// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Button,
//   Typography,
//   Grid,
//   TableContainer,
//   Table,
//   TableHead,
//   TableBody,
//   Paper,
//   Modal,
//   IconButton,
//   DialogContent,
//   MenuItem,
// } from "@mui/material";
// import CustomPagination from "../../reusableComponent/CustomPagination";
// import {
//   BootstrapDialog,
//   BootstrapDialogTitle,
//   Breadcrumb,
//   CTSRinput,
//   StyledTableCell,
//   StyledTableRow,
// } from "../../reusableComponent/Reusables";
// import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useForm, Controller } from "react-hook-form";
// import CloseIcon from "@mui/icons-material/Close";
// import { Print } from "@mui/icons-material";
// import styles from "../../../styles.module.css";
// import dayjs from "dayjs";
// import emptyCylinderInspectionService from "../../../services/emptyCylinderInspection.Service";
// import plantMasterService from "../../../services/masters/plantMaster.Service";
// import { useSelector } from "react-redux";

// const printStyles = `
//   @media print {
//     body * { visibility: hidden; }
//     .printable-area, .printable-area * { visibility: visible; }
//     .printable-area {
//       position: absolute;
//       left: 0;
//       top: 0;
//       width: 100%;
//       overflow: hidden;
//     }
//     .no-print { display: none !important; }
//     .printable-table {
//       width: 100%;
//       table-layout: fixed;
//       border-collapse: collapse;
//       page-break-inside: auto;
//       overflow: hidden;
//     }
//     .printable-table th, .printable-table td {
//       padding: 6px;
//       font-size: 12px !important;
//       text-align: left;
//       word-wrap: break-word;
//     }
//     .printable-table th {
//       background-color: #f0f0f0;
//       font-weight: bold;
//     }
//     .printable-table tr:nth-child(even) { background-color: #f9f9f9; }
//     .printable-table tr { page-break-inside: avoid; page-break-after: auto; }
//     .printable-header {
//       text-align: left;
//       margin-bottom: 15px;
//       font-size: 20px;
//       font-weight: bold;
//       color: #000;
//     }
//     .printable-subheader {
//       text-align: left;
//       margin-bottom: 15px;
//       font-size: 14px;
//       color: #333;
//     }
//     .printable-table th:nth-child(1), .printable-table td:nth-child(1) { width: 8%; }
//     .printable-table th:nth-child(2), .printable-table td:nth-child(2) { width: 15%; }
//     .printable-table th:nth-child(3), .printable-table td:nth-child(3) { width: 10%; }
//     .printable-table th:nth-child(4), .printable-table td:nth-child(4) { width: 5%; }
//     .printable-table th:nth-child(5), .printable-table td:nth-child(5) { width: 10%; }
//     .printable-table th:nth-child(6), .printable-table td:nth-child(6) { width: 10%; }
//     .printable-table th:nth-child(7), .printable-table td:nth-child(7) { width: 10%; }
//     .printable-table th:nth-child(8), .printable-table td:nth-child(8) { width: 10%; }
//   }
// `;

// const EmptyCollectionReport = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const editData = location.state || null;

//   const login_details = sessionStorage.getItem("loginUser");
//   const userD = JSON.parse(login_details);
//   const userInfo = userD.result.userInfo;
//   const depot_id = userInfo.depot_id;
//   const plant_id = userInfo.plant_id;
//   const unit_id = userInfo.depot_id || userInfo.plant_id;
//   const short_code = userInfo.depot_short_code || userInfo.plant_short_code;

//   const defaultRowsPerPage = useSelector((state) => state.grn?.rows_per_page || 15);

//   const [successMessage, setSuccessMessage] = useState("");
//   const [displayData, setDisplayData] = useState([]);
//   const [totalCount, setTotalCount] = useState(0);
//   const [plant, setPlant] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [openModal, setOpenModal] = useState(false);
//   const [selectedImage, setSelectedImage] = useState("");
//   const [info, setInfo] = useState([]);
//   const [openDetail, setDetail] = useState(false);
  
//   const [controller, setController] = useState({
//     page: 0,
//     rowsPerPage: defaultRowsPerPage,
//   });

//   const dateConversion = (date) => {
//     if (!date) return "";
//     const today = new Date(date);
//     const dd = String(today.getDate()).padStart(2, "0");
//     const mm = String(today.getMonth() + 1).padStart(2, "0");
//     const yyyy = today.getFullYear();
//     return `${dd}/${mm}/${yyyy}`;
//   };

//   const effectiveTotalCount = totalCount > 0 ? totalCount : displayData.length;
//   const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
//   const endRecord =
//     effectiveTotalCount === 0
//       ? 0
//       : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
//   const paginationInfo = `${startRecord}-${endRecord} of ${effectiveTotalCount}`;

//   const {
//     control,
//     watch,
//     formState: { errors },
//   } = useForm({
//     defaultValues: {
//       entry_date_from: editData?.entry_date
//         ? dayjs(editData.entry_date).format("YYYY-MM-DD")
//         : "",
//       entry_date_to: "",
//       plant: "",
//     },
//     resolver: async (data) => {
//       const errors = {};
//       if (!data.entry_date_from)
//         errors.entry_date_from = { message: "From Date is required" };
//       if (!data.entry_date_to)
//         errors.entry_date_to = { message: "To Date is required" };
//       if (
//         data.entry_date_from &&
//         data.entry_date_to &&
//         dayjs(data.entry_date_to).isBefore(dayjs(data.entry_date_from))
//       ) {
//         errors.entry_date_to = { message: "To Date cannot be before From Date" };
//       }
//       if (!data.plant) errors.plant = { message: "Plant is required" };
//       return { values: data, errors };
//     },
//   });

//   const entryDateFrom = watch("entry_date_from");
//   const entryDateTo = watch("entry_date_to");
//   const selectedPlant = watch("plant");

//   // ── Effect 1: Plant list + print styles ──────────────────────────────────
//   useEffect(() => {
//     async function fetchData() {
//       try {
//         setLoading(true);
//         const plantData = await plantMasterService.getPlantList({
//           page: 0,
//           size: 999,
//           searchKey: "",
//         });
//         setPlant(plantData || []);
//       } catch (error) {
//         console.error("Error fetching plant data:", error);
//         setSuccessMessage("Error fetching plant data");
//         setPlant([]);
//       } finally {
//         setLoading(false);
//       }
//     }
//     fetchData();

//     const styleSheet = document.createElement("style");
//     styleSheet.type = "text/css";
//     styleSheet.innerText = printStyles;
//     document.head.appendChild(styleSheet);
//     return () => {
//       document.head.removeChild(styleSheet);
//     };
//   }, []);

//   // ── Effect 2: Reset to page 0 when filters change ────────────────────────
//   useEffect(() => {
//     setController((prev) => ({ ...prev, page: 0 }));
//   }, [entryDateFrom, entryDateTo, selectedPlant]);

//   // ── Effect 3: Fetch data when filters OR pagination change ───────────────
//   useEffect(() => {
//     if (
//       entryDateFrom &&
//       entryDateTo &&
//       selectedPlant &&
//       !errors.entry_date_from &&
//       !errors.entry_date_to &&
//       !errors.plant
//     ) {
//       handleShow({
//         entry_date_from: entryDateFrom,
//         entry_date_to: entryDateTo,
//         plant: selectedPlant,
//       });
//     }
//   }, [entryDateFrom, entryDateTo, selectedPlant, controller.page, controller.rowsPerPage]);

//   const handleShow = async (formData) => {
//     try {
//       setLoading(true);
//       setDisplayData([]);
//       const { entry_date_from, entry_date_to, plant } = formData;

//       if (!entry_date_from || !entry_date_to) {
//         setSuccessMessage("Both From Date and To Date are required");
//         setLoading(false);
//         return;
//       }

//       const filterParams = {
//         page: controller.page,
//         size: controller.rowsPerPage,
//         searchKey: "",
//         fromDate: entry_date_from,
//         toDate: entry_date_to,
//         from_plant_id: plant === "all" ? "" : plant,
//       };

//       const response = await emptyCylinderInspectionService.getEciReport(filterParams);
//       const fetchedData = response?.data || response || [];

//       // ── total_count: backend ke response key ke hisaab se adjust karo ──
//       const serverTotalCount =
//         response?.total_count ??
//         response?.totalCount ??
//         response?.count ??
//         fetchedData.length;

//       const filteredData =
//         plant === "all"
//           ? fetchedData
//           : fetchedData.filter((row) => row.from_plant_id === Number(plant));

//       setDisplayData(filteredData);
//       setTotalCount(serverTotalCount);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       setSuccessMessage(error.message || "Error fetching data");
//       setDisplayData([]);
//       setTotalCount(0);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleImageClick = (image) => {
//     setSelectedImage(image);
//     setOpenModal(true);
//   };
//   const handleCloseModal = () => {
//     setOpenModal(false);
//     setSelectedImage("");
//   };
//   const handlePrint = () => {
//     window.print();
//   };
//   const handleDetails = (tableData) => {
//     setInfo(JSON.parse(tableData));
//     setDetail(true);
//   };
//   const handleClose = () => {
//     setDetail(false);
//   };

//   const getPlantName = (from_plant_id, short_code) => {
//     const plantData = plant.find((p) => p.plant_id === from_plant_id);
//     return plantData?.plant_name || short_code || "Unknown";
//   };

//   const getSelectedPlantName = () => {
//     if (selectedPlant === "all") return "All Plants";
//     const plantData = plant.find((p) => p.plant_id === Number(selectedPlant));
//     return plantData?.plant_name || "Unknown";
//   };

//   const handleChangePage = (event, newPage) => {
//     setController((prev) => ({ ...prev, page: newPage }));
//   };
//   const handleChangeRowsPerPage = (event) => {
//     setController({ rowsPerPage: parseInt(event.target.value, 10), page: 0 });
//   };

//   return (
//     <Box className={styles.cts_page} sx={{ padding: "0px !important", margin: "0px !important" }}>
//       <Box className={styles.body}>
//         <Breadcrumb routeSegments={[{ name: "Inspection Report" }]} />
//         <Typography className={styles.header_txt}>INSPECTION SUMMARY</Typography>

//         {/* ── Filter Row + Print Button ── */}
//        {/* ── Filter Row + Print Button ── */}
// <Box
//   className="no-print"
//   component="form"
//   sx={{
//     display: "flex",
//     flexWrap: "wrap",
//     alignItems: "flex-end",
//     gap: "12px",
//     mb: 2,
//     width: "100%",
//   }}
// >
//   {/* From Date */}
//   <Box sx={{ display: "flex", flexDirection: "column", flex: "1 1 140px", minWidth: "150px", maxWidth: { xs: "100%", sm: "300px" } }}>
//     <Typography
//       sx={{ fontSize: "12px", fontWeight: 500, color: "text.secondary", mb: "4px", whiteSpace: "nowrap" }}
//     >
//       From Date <span style={{ color: "red" }}>*</span>
//     </Typography>
//     <Controller
//       name="entry_date_from"
//       control={control}
//       render={({ field }) => (
//         <CTSRinput
//           size="small"
//           fullWidth
//           type="date"
//           {...field}
//           error={!!errors.entry_date_from}
//           helperText={errors.entry_date_from?.message}
//           InputProps={{ className: styles.CTSinput_Box }}
//         />
//       )}
//     />
//   </Box>

//   {/* To Date */}
//   <Box sx={{ display: "flex", flexDirection: "column", flex: "1 1 140px", minWidth: "150px", maxWidth: { xs: "100%", sm: "300px" } }}>
//     <Typography
//       sx={{ fontSize: "12px", fontWeight: 500, color: "text.secondary", mb: "4px", whiteSpace: "nowrap" }}
//     >
//       To Date <span style={{ color: "red" }}>*</span>
//     </Typography>
//     <Controller
//       name="entry_date_to"
//       control={control}
//       render={({ field }) => (
//         <CTSRinput
//           size="small"
//           fullWidth
//           type="date"
//           {...field}
//           error={!!errors.entry_date_to}
//           helperText={errors.entry_date_to?.message}
//           InputProps={{ className: styles.CTSinput_Box }}
//         />
//       )}
//     />
//   </Box>

//   {/* Plant */}
//   <Box sx={{ display: "flex", flexDirection: "column", flex: "2 1 180px", minWidth: "150px", maxWidth: { xs: "100%", sm: "300px" } }}>
//     <Typography
//       sx={{ fontSize: "12px", fontWeight: 500, color: "text.secondary", mb: "4px", whiteSpace: "nowrap" }}
//     >
//       Plant <span style={{ color: "red" }}>*</span>
//     </Typography>
//     <Controller
//       name="plant"
//       control={control}
//       render={({ field }) => (
//         <CTSRinput
//           select
//           size="small"
//           fullWidth
//           {...field}
//           error={!!errors.plant}
//           helperText={errors.plant?.message}
//           InputProps={{ className: styles.CTSinput_Box }}
//         >
//           <MenuItem value="">Select Plant</MenuItem>
//           <MenuItem value="all">All Plants</MenuItem>
//           {plant.map((plantItem) => (
//             <MenuItem key={plantItem.plant_id} value={plantItem.plant_id}>
//               {plantItem.plant_name}
//             </MenuItem>
//           ))}
//         </CTSRinput>
//       )}
//     />
//   </Box>

//   {/* Print Button */}
//   <Box sx={{ display: "flex", alignItems: "flex-end", flex: "0 0 auto", ml: { xs: "auto", sm: 0 } }}>
//     <Button
//       variant="outlined"
//       startIcon={<Print />}
//       onClick={handlePrint}
//       disabled={displayData.length === 0}
//       size="small"
//       sx={{ whiteSpace: "nowrap", height: "30px" }}
//     >
//       Print
//     </Button>
//   </Box>
// </Box>

//         {/* ── Table ── */}
//         <Grid item xs={12}>
//           <Paper sx={{ width: "100%" }}>
//             <Box className="printable-area">
//               <Typography
//                 variant="h1"
//                 className="printable-header"
//                 sx={{ display: "none", "@media print": { display: "block" } }}
//               >
//                 Inspection Report
//               </Typography>
//               <Typography
//                 variant="h1"
//                 className="printable-subheader"
//                 sx={{ display: "none", "@media print": { display: "block" } }}
//               >
//                 {`Date Range: ${dateConversion(entryDateFrom)} to ${dateConversion(
//                   entryDateTo
//                 )} | Plant: ${getSelectedPlantName()}`}
//               </Typography>

//               <TableContainer component={Paper} sx={{ overflowX: "auto" }}>
//                 <Table size="small" stickyHeader className="printable-table">
//                   <TableHead>
//                     <StyledTableRow>
//                       <StyledTableCell sx={{ textAlign: "left !important", paddingLeft: "5px" }}>
//                         Sr No
//                       </StyledTableCell>
//                       <StyledTableCell sx={{ textAlign: "left !important", paddingLeft: "5px" }}>
//                         Entry No
//                       </StyledTableCell>
//                       <StyledTableCell sx={{ textAlign: "left !important", paddingLeft: "5px" }}>
//                         Entry Date
//                       </StyledTableCell>
//                       <StyledTableCell sx={{ textAlign: "left !important", paddingLeft: "5px" }}>
//                         Shift
//                       </StyledTableCell>
//                       <StyledTableCell sx={{ textAlign: "left !important", paddingLeft: "5px" }}>
//                         Shift Time
//                       </StyledTableCell>
//                       <StyledTableCell sx={{ textAlign: "left !important", paddingLeft: "5px" }}>
//                         Done By
//                       </StyledTableCell>
//                       <StyledTableCell sx={{ textAlign: "left !important", paddingLeft: "5px" }}>
//                         Plant Name
//                       </StyledTableCell>
//                       <StyledTableCell sx={{ textAlign: "left !important", paddingLeft: "5px" }}>
//                         No of Cyl
//                       </StyledTableCell>
//                     </StyledTableRow>
//                   </TableHead>
//                   <TableBody sx={{ backgroundColor: "#fff" }}>
//                     {loading ? (
//                       <StyledTableRow>
//                         <StyledTableCell colSpan={8} align="center">
//                           <Typography>Loading data...</Typography>
//                         </StyledTableCell>
//                       </StyledTableRow>
//                     ) : displayData.length === 0 ? (
//                       <StyledTableRow>
//                         <StyledTableCell colSpan={8} align="center">
//                           <Typography>No data found</Typography>
//                         </StyledTableCell>
//                       </StyledTableRow>
//                     ) : (
//                       displayData.map((row, index) => (
//                         <StyledTableRow key={index}>
//                           <StyledTableCell align="left">
//                             {controller.page * controller.rowsPerPage + index + 1}
//                           </StyledTableCell>
//                           <StyledTableCell className={styles.inspection_cell}>
//                             {row.entry_no}
//                           </StyledTableCell>
//                           <StyledTableCell className={styles.inspection_cell}>
//                             {dateConversion(row.entry_date)}
//                           </StyledTableCell>
//                           <StyledTableCell className={styles.inspection_cell}>
//                             {row.shift}
//                           </StyledTableCell>
//                           <StyledTableCell className={styles.inspection_cell}>
//                             {row.shift_time}
//                           </StyledTableCell>
//                           <StyledTableCell className={styles.inspection_cell}>
//                             {row.done_by}
//                           </StyledTableCell>
//                           <StyledTableCell className={styles.inspection_cell}>
//                             {getPlantName(row.from_plant_id, row.short_code)}
//                           </StyledTableCell>
//                           <StyledTableCell
//                             sx={{ color: "blue", cursor: "pointer" }}
//                             align="left"
//                             className={styles.inspection_cell}
//                             onClick={() => handleDetails(row.tableData)}
//                           >
//                             {JSON.parse(row.tableData)?.length || 0}
//                           </StyledTableCell>
//                         </StyledTableRow>
//                       ))
//                     )}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             </Box>

//             <CustomPagination
//               page={controller.page}
//               rowsPerPage={controller.rowsPerPage}
//               totalCount={effectiveTotalCount || 0}
//               onPageChange={(newPage) => handleChangePage(null, newPage)}
//               onRowsPerPageChange={handleChangeRowsPerPage}
//               className="no-print"
//             />
//           </Paper>
//         </Grid>

//         <ReusableSnackbar
//           open={!!successMessage}
//           onClose={() => setSuccessMessage("")}
//           message={successMessage}
//           autoHideDuration={2000}
//           vertical="top"
//           horizontal="right"
//           className="no-print"
//         />

//         <Modal
//           open={openModal}
//           onClose={handleCloseModal}
//           sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
//           className="no-print"
//         >
//           <Box
//             sx={{
//               position: "relative",
//               maxWidth: "90%",
//               maxHeight: "90%",
//               bgcolor: "background.paper",
//               boxShadow: 24,
//               p: 2,
//               borderRadius: 2,
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//             }}
//           >
//             <IconButton
//               sx={{ position: "absolute", top: 8, right: 8, zIndex: 1 }}
//               onClick={handleCloseModal}
//             >
//               <CloseIcon />
//             </IconButton>
//             <img
//               src={selectedImage}
//               alt="Full-size receipt"
//               style={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain" }}
//               onError={(e) => {
//                 e.target.src = "/path/to/fallback/image.jpg";
//               }}
//             />
//           </Box>
//         </Modal>

//         <BootstrapDialog
//           PaperProps={{ sx: { minWidth: "90%", maxHeight: "90%" } }}
//           onClose={handleClose}
//           open={openDetail}
//           className="no-print"
//         >
//           <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
//             Details
//           </BootstrapDialogTitle>
//           <DialogContent dividers>
//             <TableContainer
//               component={Paper}
//               className={`${styles.list_tbl_container} printable-table`}
//             >
//               <Table size="small" stickyHeader className="printable-table">
//                 <TableHead className={styles.table_head_container}>
//                   <StyledTableRow>
//                     <StyledTableCell align="left">Sr No</StyledTableCell>
//                     <StyledTableCell align="left">Cylinder No</StyledTableCell>
//                     <StyledTableCell align="left">Tag No</StyledTableCell>
//                     <StyledTableCell align="left">Valve Condition</StyledTableCell>
//                     <StyledTableCell align="left">Fusible Plug</StyledTableCell>
//                     <StyledTableCell align="left">Painting</StyledTableCell>
//                     <StyledTableCell align="left">Cyl Cap Avl</StyledTableCell>
//                     <StyledTableCell align="left">Result</StyledTableCell>
//                     <StyledTableCell align="left">Current Tare Wt</StyledTableCell>
//                     <StyledTableCell align="left">Actual Tare Wt</StyledTableCell>
//                     <StyledTableCell align="left">Actual Tare Wt (After Solvent)</StyledTableCell>
//                     <StyledTableCell align="left">Qty Of Solvent</StyledTableCell>
//                     <StyledTableCell align="left">Acetone Drum Tag No</StyledTableCell>
//                   </StyledTableRow>
//                 </TableHead>
//                 <TableBody sx={{ backgroundColor: "#fff" }}>
//                   {info.map((row, index) => (
//                     <StyledTableRow key={index}>
//                       <StyledTableCell align="center">{index + 1}</StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>
//                         {row.cylinder_no}
//                       </StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>
//                         {row.tag_no}
//                       </StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>
//                         {row.valve_condition}
//                       </StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>
//                         {row.fusible_plug}
//                       </StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>
//                         {row.painting}
//                       </StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>
//                         {row.cyl_cap_avl}
//                       </StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>
//                         {row.eci_result}
//                       </StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>
//                         {row.current_tare_wt}
//                       </StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>
//                         {row.actual_tare_wt}
//                       </StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>
//                         {row.actual_tare_wt_aft_sol}
//                       </StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>
//                         {parseFloat(row.qty_solvent).toFixed(2)}
//                       </StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>
//                         {row.acetone_drum_tag_no}
//                       </StyledTableCell>
//                     </StyledTableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           </DialogContent>
//         </BootstrapDialog>
//       </Box>
//     </Box>
//   );
// };

// export default EmptyCollectionReport;


import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  Paper,
  Modal,
  IconButton,
  DialogContent,
  MenuItem,
  Dialog,
} from "@mui/material";
import CustomPagination from "../../reusableComponent/CustomPagination";
import {
  Breadcrumb,
  CTSRinput,
  StyledTableCell,
  StyledTableRow,
  dateConversion as dateConversionUtil,
} from "../../reusableComponent/Reusables";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import { useLocation } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import CloseIcon from "@mui/icons-material/Close";
import { Print } from "@mui/icons-material";
import styles from "../../../styles.module.css";
import dayjs from "dayjs";
import emptyCylinderInspectionService from "../../../services/emptyCylinderInspection.Service";
import plantMasterService from "../../../services/masters/plantMaster.Service";
import { useSelector } from "react-redux";

const printStyles = `
  @media print {
    body * { visibility: hidden; }
    .printable-area, .printable-area * { visibility: visible; }
    .printable-area {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      overflow: hidden;
    }
    .no-print { display: none !important; }
    .printable-table {
      width: 100%;
      table-layout: fixed;
      border-collapse: collapse;
      page-break-inside: auto;
      overflow: hidden;
    }
    .printable-table th, .printable-table td {
      padding: 6px;
      font-size: 12px !important;
      text-align: left;
      word-wrap: break-word;
    }
    .printable-table th {
      background-color: #f0f0f0;
      font-weight: bold;
    }
    .printable-table tr:nth-child(even) { background-color: #f9f9f9; }
    .printable-table tr { page-break-inside: avoid; page-break-after: auto; }
    .printable-header {
      text-align: left;
      margin-bottom: 15px;
      font-size: 20px;
      font-weight: bold;
      color: #000;
    }
    .printable-subheader {
      text-align: left;
      margin-bottom: 15px;
      font-size: 14px;
      color: #333;
    }
    .printable-table th:nth-child(1), .printable-table td:nth-child(1) { width: 8%; }
    .printable-table th:nth-child(2), .printable-table td:nth-child(2) { width: 15%; }
    .printable-table th:nth-child(3), .printable-table td:nth-child(3) { width: 10%; }
    .printable-table th:nth-child(4), .printable-table td:nth-child(4) { width: 5%; }
    .printable-table th:nth-child(5), .printable-table td:nth-child(5) { width: 10%; }
    .printable-table th:nth-child(6), .printable-table td:nth-child(6) { width: 10%; }
    .printable-table th:nth-child(7), .printable-table td:nth-child(7) { width: 10%; }
    .printable-table th:nth-child(8), .printable-table td:nth-child(8) { width: 10%; }
  }
`;

const EmptyCollectionReport = () => {
  const location = useLocation();
  const editData = location.state || null;

  const login_details = sessionStorage.getItem("loginUser");
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;

  const defaultRowsPerPage = useSelector((state) => state.grn?.rows_per_page || 15);

  const [successMessage, setSuccessMessage] = useState("");
  const [displayData, setDisplayData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [plant, setPlant] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [info, setInfo] = useState([]);
  const [openDetail, setDetail] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage,
  });

  const dateConversion = (date) => {
    if (!date) return "";
    const today = new Date(date);
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const yyyy = today.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  const effectiveTotalCount = totalCount > 0 ? totalCount : displayData.length;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord =
    effectiveTotalCount === 0
      ? 0
      : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);

  const {
    control,
    watch,
    formState: { errors },
  } = useForm({
 defaultValues: {
  entry_date_from: editData?.entry_date
    ? dayjs(editData.entry_date).format("YYYY-MM-DD")
    : dayjs().format("YYYY-MM-DD"),        // ← today
  entry_date_to: dayjs().format("YYYY-MM-DD"),  // ← today
  plant: "",
},
    resolver: async (data) => {
      const errors = {};
      if (!data.entry_date_from)
        errors.entry_date_from = { message: "From Date is required" };
      if (!data.entry_date_to)
        errors.entry_date_to = { message: "To Date is required" };
      if (
        data.entry_date_from &&
        data.entry_date_to &&
        dayjs(data.entry_date_to).isBefore(dayjs(data.entry_date_from))
      ) {
        errors.entry_date_to = { message: "To Date cannot be before From Date" };
      }
      if (!data.plant) errors.plant = { message: "Plant is required" };
      return { values: data, errors };
    },
  });

  const entryDateFrom = watch("entry_date_from");
  const entryDateTo = watch("entry_date_to");
  const selectedPlant = watch("plant");

  // ── Effect 1: Plant list + print styles ──────────────────────────────────
  useEffect(() => {
    async function fetchPlants() {
      try {
        setLoading(true);
        const plantData = await plantMasterService.getPlantList({
          page: 0,
          size: 999,
          searchKey: "",
        });
        setPlant(plantData || []);
      } catch (error) {
        setSuccessMessage("Error fetching plant data");
        setPlant([]);
      } finally {
        setLoading(false);
      }
    }
    fetchPlants();

    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = printStyles;
    document.head.appendChild(styleSheet);
    return () => { document.head.removeChild(styleSheet); };
  }, []);

  // ── Effect 2: Reset page when filters change ─────────────────────────────
  useEffect(() => {
    setController((prev) => ({ ...prev, page: 0 }));
  }, [entryDateFrom, entryDateTo, selectedPlant]);

  // ── Effect 3: Fetch data on filters / pagination change ──────────────────
  useEffect(() => {
    if (
      entryDateFrom &&
      entryDateTo &&
      selectedPlant &&
      !errors.entry_date_from &&
      !errors.entry_date_to &&
      !errors.plant
    ) {
      handleShow({ entry_date_from: entryDateFrom, entry_date_to: entryDateTo, plant: selectedPlant });
    }
  }, [entryDateFrom, entryDateTo, selectedPlant, controller.page, controller.rowsPerPage]);

  const handleShow = async (formData) => {
    try {
      setLoading(true);
      setDisplayData([]);
      const { entry_date_from, entry_date_to, plant } = formData;
      if (!entry_date_from || !entry_date_to) {
        setSuccessMessage("Both From Date and To Date are required");
        return;
      }
      const filterParams = {
        page: controller.page,
        size: controller.rowsPerPage,
        searchKey: "",
        fromDate: entry_date_from,
        toDate: entry_date_to,
        from_plant_id: plant === "all" ? "" : plant,
      };
      const response = await emptyCylinderInspectionService.getEciReport(filterParams);
      const fetchedData = response?.data || response || [];
      const serverTotalCount =
        response?.total_count ?? response?.totalCount ?? response?.count ?? fetchedData.length;
      const filteredData =
        plant === "all"
          ? fetchedData
          : fetchedData.filter((row) => row.from_plant_id === Number(plant));
      setDisplayData(filteredData);
      setTotalCount(serverTotalCount);
    } catch (error) {
      setSuccessMessage(error.message || "Error fetching data");
      setDisplayData([]);
      setTotalCount(0);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => { setOpenModal(false); setSelectedImage(""); };
  const handlePrint = () => { window.print(); };

  // ── Entry No click → open detail dialog ──────────────────────────────────
  const handleDetails = (row) => {
    setSelectedRow(row);
    try {
      setInfo(JSON.parse(row.tableData || "[]"));
    } catch {
      setInfo([]);
    }
    setDetail(true);
  };

  const handleClose = () => {
    setDetail(false);
    setSelectedRow(null);
    setInfo([]);
  };

  const getPlantName = (from_plant_id, short_code) => {
    const plantData = plant.find((p) => p.plant_id === from_plant_id);
    return plantData?.plant_name || short_code || "Unknown";
  };

  const getSelectedPlantName = () => {
    if (selectedPlant === "all") return "All Plants";
    const plantData = plant.find((p) => p.plant_id === Number(selectedPlant));
    return plantData?.plant_name || "Unknown";
  };

  const handleChangePage = (event, newPage) => {
    setController((prev) => ({ ...prev, page: newPage }));
  };
  const handleChangeRowsPerPage = (event) => {
    setController({ rowsPerPage: parseInt(event.target.value, 10), page: 0 });
  };

  // ── Cylinder table columns ────────────────────────────────────────────────
  const cylinderHeaders = [
    "Sr No", "Cylinder No", "Tag No", "Valve Condition", "Fusible Plug",
    "Painting", "Cyl Cap Avl", "Result", "Current Tare Wt", "Actual Tare Wt",
    "Actual Tare Wt (After Solvent)", "Qty Of Solvent", "Acetone Drum Tag No",
  ];

  return (
    <Box className={styles.cts_page} sx={{ padding: "0px !important", margin: "0px !important" }}>
      <Box className={styles.body}>
        <Breadcrumb routeSegments={[{ name: "Inspection Report" }]} />
        <Typography className={styles.header_txt}>INSPECTION SUMMARY</Typography>

        {/* ── Filter Row ── */}
        <Box
          className="no-print"
          component="form"
          sx={{ display: "flex", flexWrap: "wrap", alignItems: "flex-end", gap: "12px", mb: 2, width: "100%" }}
        >
          {/* From Date */}
          <Box sx={{ display: "flex", flexDirection: "column", flex: "1 1 140px", minWidth: "150px", maxWidth: { xs: "100%", sm: "300px" } }}>
            <Typography sx={{ fontSize: "12px", fontWeight: 500, color: "text.secondary", mb: "4px", whiteSpace: "nowrap" }}>
              From Date <span style={{ color: "red" }}>*</span>
            </Typography>
            <Controller
              name="entry_date_from"
              control={control}
              render={({ field }) => (
                <CTSRinput
                  size="small" fullWidth type="date" {...field}
                  error={!!errors.entry_date_from}
                  helperText={errors.entry_date_from?.message}
                  InputProps={{ className: styles.CTSinput_Box }}
                />
              )}
            />
          </Box>

          {/* To Date */}
          <Box sx={{ display: "flex", flexDirection: "column", flex: "1 1 140px", minWidth: "150px", maxWidth: { xs: "100%", sm: "300px" } }}>
            <Typography sx={{ fontSize: "12px", fontWeight: 500, color: "text.secondary", mb: "4px", whiteSpace: "nowrap" }}>
              To Date <span style={{ color: "red" }}>*</span>
            </Typography>
            <Controller
              name="entry_date_to"
              control={control}
              render={({ field }) => (
                <CTSRinput
                  size="small" fullWidth type="date" {...field}
                  error={!!errors.entry_date_to}
                  helperText={errors.entry_date_to?.message}
                  InputProps={{ className: styles.CTSinput_Box }}
                />
              )}
            />
          </Box>

          {/* Plant */}
          <Box sx={{ display: "flex", flexDirection: "column", flex: "2 1 180px", minWidth: "150px", maxWidth: { xs: "100%", sm: "300px" } }}>
            <Typography sx={{ fontSize: "12px", fontWeight: 500, color: "text.secondary", mb: "4px", whiteSpace: "nowrap" }}>
              Plant <span style={{ color: "red" }}>*</span>
            </Typography>
            <Controller
              name="plant"
              control={control}
              render={({ field }) => (
                <CTSRinput
                  select size="small" fullWidth {...field}
                  error={!!errors.plant}
                  helperText={errors.plant?.message}
                  InputProps={{ className: styles.CTSinput_Box }}
                >
                  <MenuItem value="">Select Plant</MenuItem>
                  <MenuItem value="all">All Plants</MenuItem>
                  {plant.map((plantItem) => (
                    <MenuItem key={plantItem.plant_id} value={plantItem.plant_id}>
                      {plantItem.plant_name}
                    </MenuItem>
                  ))}
                </CTSRinput>
              )}
            />
          </Box>

          {/* Print Button */}
          <Box sx={{ display: "flex", alignItems: "flex-end", flex: "0 0 auto", ml: { xs: "auto", sm: 0 } }}>
            <Button
              variant="outlined" startIcon={<Print />} onClick={handlePrint}
              disabled={displayData.length === 0} size="small"
              sx={{ whiteSpace: "nowrap", height: "30px" }}
            >
              Print
            </Button>
          </Box>
        </Box>
{/* 
     <Box sx={{ display: "flex", justifyContent: "flex-end", ml: 10 }} className="no-print">
  <Button
    variant="outlined" startIcon={<Print />} onClick={handlePrint}
    disabled={displayData.length === 0} size="small"
  
  >
 
  </Button>
</Box> */}
        {/* ── Main Table ── */}
        <Grid item xs={12}>
          <Paper sx={{ width: "100%" }}>
            <Box className="printable-area">
              <Typography variant="h1" className="printable-header"
                sx={{ display: "none", "@media print": { display: "block" } }}>
                Inspection Report
              </Typography>
              <Typography variant="h1" className="printable-subheader"
                sx={{ display: "none", "@media print": { display: "block" } }}>
                {`Date Range: ${dateConversion(entryDateFrom)} to ${dateConversion(entryDateTo)} | Plant: ${getSelectedPlantName()}`}
              </Typography>

              <TableContainer component={Paper} sx={{ overflowX: "auto" }}>
                <Table size="small" stickyHeader className="printable-table">
                  <TableHead>
                    <StyledTableRow>
                      {["Sr No", "Entry No", "Entry Date", "Shift", "Shift Time", "Done By", "Plant Name", "No of Cyl"].map((h) => (
                        <StyledTableCell key={h} sx={{ textAlign: "left !important", paddingLeft: "5px" }}>
                          {h}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </TableHead>
                  <TableBody sx={{ backgroundColor: "#fff" }}>
                    {loading ? (
                      <StyledTableRow>
                        <StyledTableCell colSpan={8} align="center">
                          <Typography>Loading data...</Typography>
                        </StyledTableCell>
                      </StyledTableRow>
                    ) : displayData.length === 0 ? (
                      <StyledTableRow>
                        <StyledTableCell colSpan={8} align="center">
                          <Typography>No data found</Typography>
                        </StyledTableCell>
                      </StyledTableRow>
                    ) : (
                      displayData.map((row, index) => (
                        <StyledTableRow key={index}>
                          <StyledTableCell align="left">
                            {controller.page * controller.rowsPerPage + index + 1}
                          </StyledTableCell>

                          {/* ── Entry No — clickable ── */}
                         {/* Entry No — clickable */}
<StyledTableCell
  sx={{
    cursor: "pointer",
    fontWeight: "bold",
    "& a, & span": { color: "#1976d2 !important" },
  }}
  onClick={() => handleDetails(row)}
>
  <Typography
    sx={{
      fontSize: "12px",
      fontWeight: "bold",
      cursor: "pointer",
      color: "#1976d2 !important",   // ← !important — even/odd row override
      textDecoration: "underline",
    }}
  >
    {row.entry_no}
  </Typography>
</StyledTableCell>

                          <StyledTableCell className={styles.inspection_cell}>
                            {dateConversion(row.entry_date)}
                          </StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{row.shift}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{row.shift_time}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>  {row.inspection_done_by || row.done_by || "N/A"}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>
                            {getPlantName(row.from_plant_id, row.short_code)}
                          </StyledTableCell>
                          <StyledTableCell align="left" className={styles.inspection_cell}>
                            {JSON.parse(row.tableData)?.length || 0}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            <CustomPagination
              page={controller.page}
              rowsPerPage={controller.rowsPerPage}
              totalCount={effectiveTotalCount || 0}
              onPageChange={(newPage) => handleChangePage(null, newPage)}
              onRowsPerPageChange={handleChangeRowsPerPage}
              className="no-print"
            />
          </Paper>
        </Grid>

        {/* ── Snackbar ── */}
        <ReusableSnackbar
          open={!!successMessage}
          onClose={() => setSuccessMessage("")}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
          className="no-print"
        />

        {/* ── Image Modal ── */}
        <Modal
          open={openModal}
          onClose={handleCloseModal}
          sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
          className="no-print"
        >
          <Box sx={{ position: "relative", maxWidth: "90%", maxHeight: "90%", bgcolor: "background.paper", boxShadow: 24, p: 2, borderRadius: 2, display: "flex", justifyContent: "center", alignItems: "center" }}>
            <IconButton sx={{ position: "absolute", top: 8, right: 8, zIndex: 1 }} onClick={handleCloseModal}>
              <CloseIcon />
            </IconButton>
            <img
              src={selectedImage} alt="Full-size receipt"
              style={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain" }}
              onError={(e) => { e.target.src = "/path/to/fallback/image.jpg"; }}
            />
          </Box>
        </Modal>

        {/* ── Detail Dialog (QualityEntryList style) ── */}
        <Dialog
          open={openDetail}
          onClose={handleClose}
          maxWidth={false}
          className="no-print"
          sx={{
            "& .MuiDialog-paper": {
              margin: "auto",
              width: "92vw",
              maxHeight: "85vh",
              boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
              overflow: "hidden",
              fontFamily: "'Inter', Arial, sans-serif",
            },
          }}
        >
          {/* Header */}
          <Box sx={{ background: "#1C3A5E", padding: "14px 22px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#fff", letterSpacing: "0.5px", fontFamily: "'Inter', Arial, sans-serif" }}>
              INSPECTION DETAILS
            </Typography>
            <IconButton onClick={handleClose} sx={{ color: "#fff", p: 0.5 }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <DialogContent sx={{ padding: "20px 24px", background: "#F4F7FB", overflowY: "auto" }}>

            {/* ── Entry Info Card ── */}
            <Box sx={{ background: "#fff", border: "1px solid #E2E8F0", overflow: "hidden", mb: 2.5 }}>
              <Box sx={{ background: "#2A4F7A", padding: "9px 18px" }}>
                <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#fff", letterSpacing: "0.4px", fontFamily: "'Inter', Arial, sans-serif" }}>
                  📋 Entry Information
                </Typography>
              </Box>
              <Grid container>
                {/* Row 1 */}
                <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                  <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Entry No</Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#1C3A5E", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.entry_no || "N/A"}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                  <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Entry Date</Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{dateConversion(selectedRow?.entry_date)}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                  <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Shift</Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.shift || "N/A"}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} sx={{ borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                  <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Shift Time</Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.shift_time || "N/A"}</Typography>
                </Grid>
                {/* Row 2 */}
                <Grid item xs={12} sm={6} md={6} sx={{ borderRight: "1px solid #EDF2F7", padding: "12px 16px" }}>
                  <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Done By</Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>  {selectedRow?.inspection_done_by || selectedRow?.done_by || "N/A"}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} sx={{ padding: "12px 16px" }}>
                  <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Plant Name</Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
                    {getPlantName(selectedRow?.from_plant_id, selectedRow?.short_code)}
                  </Typography>
                </Grid>
              </Grid>
            </Box>

            {/* ── Cylinder Details Table ── */}
            <Box sx={{ background: "#fff", border: "1px solid #E2E8F0", overflow: "hidden" }}>
              {/* <Box sx={{ background: "#2A4F7A", padding: "9px 18px" }}>
                <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#fff", letterSpacing: "0.4px", fontFamily: "'Inter', Arial, sans-serif" }}>
                  🔵 Cylinder Details ({info.length})
                </Typography>
              </Box> */}
              <TableContainer sx={{ maxHeight: "350px" }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <StyledTableRow>
                      {cylinderHeaders.map((header) => (
                        <StyledTableCell
                          key={header}
                          align="center"
                          sx={{
                            backgroundColor: "#1C3A5E !important",
                            color: "#fff !important",
                            fontFamily: "'Inter', Arial, sans-serif",
                            fontWeight: 700,
                            fontSize: "11px",
                            padding: "10px 8px",
                            whiteSpace: "nowrap",
                            borderRight: "1px solid rgba(255,255,255,0.1)",
                          }}
                        >
                          {header}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {info.length > 0 ? (
                      info.map((row, index) => (
                        <StyledTableRow
                          key={index}
                          sx={{ backgroundColor: index % 2 === 0 ? "#fff" : "#F8FAFC", "&:hover": { backgroundColor: "#EBF4FF" } }}
                        >
                          {[
                            index + 1,
                            row.cylinder_no || "N/A",
                            row.tag_no || "N/A",
                            row.valve_condition || "N/A",
                            row.fusible_plug || "N/A",
                            row.painting || "N/A",
                            row.cyl_cap_avl || "N/A",
                            row.eci_result || "N/A",
                            row.current_tare_wt || "N/A",
                            row.actual_tare_wt || "N/A",
                            row.actual_tare_wt_aft_sol || "N/A",
                            parseFloat(row.qty_solvent || 0).toFixed(2),
                            row.acetone_drum_tag_no || "N/A",
                          ].map((val, ci) => (
                            <StyledTableCell
                              key={ci}
                              align="center"
                              sx={{
                                fontSize: "11px",
                                fontFamily: "'Inter', Arial, sans-serif",
                                color: "#2D3748",
                                padding: "8px 6px",
                                borderBottom: "1px solid #EDF2F7",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {val}
                            </StyledTableCell>
                          ))}
                        </StyledTableRow>
                      ))
                    ) : (
                      <StyledTableRow>
                        <StyledTableCell
                          colSpan={cylinderHeaders.length}
                          align="center"
                          sx={{ py: 5, fontSize: "13px", color: "#A0AEC0", fontFamily: "'Inter', Arial, sans-serif" }}
                        >
                          No cylinder details available
                        </StyledTableCell>
                      </StyledTableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </DialogContent>

          {/* Footer */}
          <Box sx={{ padding: "12px 24px", background: "#F8FAFC", borderTop: "1px solid #E2E8F0", display: "flex", justifyContent: "flex-end" }}>
            <Button
              onClick={handleClose}
              sx={{
                background: "#E53E3E", color: "#fff", fontSize: "13px", fontWeight: 600,
                textTransform: "none", padding: "7px 20px", borderRadius: "8px",
                fontFamily: "'Inter', Arial, sans-serif",
                "&:hover": { background: "#971f16" },
              }}
            >
              Close
            </Button>
          </Box>
        </Dialog>

      </Box>
    </Box>
  );
};

export default EmptyCollectionReport;